import Table from "../../../../../common/components/table";


export const TasksComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedSheduledTasksValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedSheduledTasksValues}
                onEdit={handleEdit} headingName="Tasks Details"
                additionButtons={additionButtons} onDelete={handleDelete} />
        </div>
    )
}
export default TasksComponent;
